import images from 'assets/images/images'
import { PropTypes } from 'prop-types'
const Modal = ({ children, onClose, title, mmodalClass, closeModal, modalContainerClass, headerShow }) => {
	return (
		onClose && <div className={`modal ${mmodalClass}`}>
			<div className={`modal-container container ${modalContainerClass}`}>
				{headerShow && <div className="modal-container-header">
					<img onClick={() => closeModal()} src={images.close} className="modal-container-header-close mr-3" />
					{title && <div className="modal-container-header-title ml-3">
						{title}
					</div>}
				</div>}
				{children}
			</div>
		</div>
	)
}

Modal.propTypes = {
	children: PropTypes.node,
	onClose: PropTypes.bool,
	closeModal: PropTypes.func,
	mmodalClass: PropTypes.string,
	title: PropTypes.string
}

export default Modal
